import * as React from 'react';

function Hamburger(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 31 18" {...props}>
      <g stroke="currentColor" fill="none">
        <path d="M29.5 16.5h-21M29.5 9.5h-28M29.5 2h-14" />
      </g>
    </svg>
  );
}

const MemoHamburger = React.memo(Hamburger);
export default MemoHamburger;
